import React from "react";
import SendIcon from "@mui/icons-material/Send";
import { Button, IconButton } from "@mui/material";
import NRCB_ICAR_image from "../../assets/Logo/NRCB_ICAR.jpg";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { contactUsMail } from "../../Redux/BuyerRedux";

function ContactUs() {
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    name: "",
    email: "",
    contactNumber: "",
    subject: "",
    content: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      name: form.name,
      emailId: form.email,
      contactNumber: form.contactNumber,
      subject: form.subject,
      content: form.content,
    };
    dispatch(contactUsMail(payload));
  };

   return (
    <div className='container my-5'>
      <div className='row mb-4'>
        <div className='col-12 d-flex justify-content-center'>
          <h3 className='underline'>Contact Us</h3>
        </div>
      </div>

      <div className='row'>
        <div className='col-md-5 col-sm-12'>
          <div
            style={{
              background: '#fff',
              boxShadow: '0px 4px 8px 5px rgba(0, 0, 0, 0.1)',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <h4 className='mt-3 text-center'>Drop a message with a mail</h4>

            <form className='mt-4 mx-5' onSubmit={handleSubmit}>
              <input
                type='text'
                className='form-control mb-4'
                name='name'
                placeholder='Name'
                value={form.name}
                onChange={handleChange}
              />

              <input
                type='email'
                className='form-control mb-4'
                name='email'
                placeholder='Email id'
                value={form.email}
                onChange={handleChange}
              />

              <input
                type='text'
                className='form-control mb-4'
                name='contactNumber'
                placeholder='Contact Number'
                value={form.contactNumber}
                onChange={handleChange}
              />

              <input
                type='text'
                className='form-control mb-4'
                name='subject'
                placeholder='Subject'
                value={form.subject}
                onChange={handleChange}
              />

              <textarea
                className='form-control mb-4'
                style={{ height: '100px' }}
                name='content'
                placeholder='Leave a comment here'
                value={form.content}
                onChange={handleChange}
              ></textarea>

              <div className='d-flex justify-content-center'>
                <Button
                  className='m-3'
                  color='success'
                  variant='contained'
                  fullWidth
                  endIcon={<SendIcon />}
                  type='submit'
                >
                  Send Now
                </Button>
              </div>
            </form>
          </div>
        </div>

        <div className='col-md-7 col-sm-12'>
          <img
            className='img-fluid'
            src={NRCB_ICAR_image}
            alt='NRCB'
            style={{ height: '510px', marginRight: '10px' }}
          />
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
